import { Tooltip } from '@mui/material'
import { HourglassEmpty, GraphicEq, DoneAll } from '@mui/icons-material'
import { DictationStatus } from '@services/dtos'

type Props = {
  status: DictationStatus
}

const config: Record<DictationStatus, {
  icon: React.ReactNode
  bg: string
  border: string
  tooltip: string
}> = {
  [DictationStatus.AWAITING_TRANSCRIPTION]: {
    icon: <HourglassEmpty sx={{ fontSize: 18, color: '#92400E' }} />,
    bg: '#FEF3C7',
    border: '#FDE68A',
    tooltip: 'En attente de transcription',
  },
  [DictationStatus.TRANSCRIBING]: {
    icon: <GraphicEq sx={{ fontSize: 18, color: '#1E40AF' }} />,
    bg: '#DBEAFE',
    border: '#BFDBFE',
    tooltip: 'Transcription en cours...',
  },
  [DictationStatus.TRANSCRIBED]: {
    icon: <DoneAll sx={{ fontSize: 18, color: '#065F46' }} />,
    bg: '#D1FAE5',
    border: '#A7F3D0',
    tooltip: 'Dictée transcrite',
  },
}

export const DictationStatusBadge: React.FC<Props> = ({ status }) => {
  const c = config[status]

  return (
    <Tooltip title={c.tooltip} >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          background: c.bg,
          border: `1px solid ${c.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'default',
        }}
      >
        {c.icon}
      </div>
    </Tooltip>
  )
}